import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../ui/Modal';

export default class ClipEmailNotificationModal extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  };

  render() {
    return (
      <Modal
        show={this.props.open}
        width={'300px'} >
        <div className="clip-modal clip-modal-notification">
          <div className="clip-modal-body">
            <p>
              <span className="aw-icon aw-icon-white aw-icon-clip"></span>{this.props.serviceId == 3 ? "製品名とURLを送信しました" : this.props.serviceId == 5 ? "カタログのURLを送信しました" : "記事のURLを送信しました"}
            </p>
          </div>
        </div>
      </Modal>
    )
  }

}
